<template>    
    <v-textarea
      :label="modelValue.title"
      :name="modelValue.name"
      :id="modelValue.id"
      :model-value="modelValue.value"
      @update:model-value="updateText"
      :error-messages="modelValue.error"
      auto-grow
      bg-color="white"
    >
      <template v-slot:append-inner v-if="modelValue.mandatory">
        <v-icon color="red" size="small">mdi-asterisk</v-icon>
      </template>
    </v-textarea>
</template>

<script>
export default {
    name: 'TextAreaComponent',
    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            isEditing: false,
            editedText: this.text
        };
    },

    methods: {
        updateText(newValue) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                value: newValue,
                error: '', // Reset any previous error
            });
        }
    }
}
</script>
